import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Voice from "./Voice";
import { BASE_SAMPLE_TUNING } from "../Constants";

var SamplePlayer =
/*#__PURE__*/
function (_Voice) {
  _inherits(SamplePlayer, _Voice);

  function SamplePlayer(context, buffer) {
    var _this;

    var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var tune = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sampleTuneFrequency = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : BASE_SAMPLE_TUNING;

    _classCallCheck(this, SamplePlayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SamplePlayer).call(this, context));
    _this.buffer = _this.context.createBufferSource();
    _this.buffer.buffer = buffer;
    _this.tune = tune;
    _this.loop = loop;
    _this.sampleTuneFrequency = sampleTuneFrequency;
    _this._loopstart = 0;
    _this._loopend = 0;
    _this.loopStart = 0;
    _this.loopEnd = 1;
    return _this;
  }

  _createClass(SamplePlayer, [{
    key: "init",
    value: function init() {
      this.buffer.connect(this.ampEnvelope.output);
      this.buffer.loop = this.loop;
      this.buffer.loopStart = this._loopstart;
      this.buffer.loopEnd = this._loopend;
      this.partials.push(this.buffer);
    }
  }, {
    key: "on",
    value: function on(MidiEvent) {
      var _this2 = this;

      var frequency = MidiEvent.frequency;
      this.value = MidiEvent.value;
      this.partials.forEach(function (osc) {
        osc.start(_this2.context.currentTime);

        if (_this2.tune) {
          osc.playbackRate.value = frequency / _this2.sampleTuneFrequency;
        }
      });
      this.ampEnvelope.on(MidiEvent.velocity || MidiEvent);
    }
  }, {
    key: "loopStart",
    set: function set(value) {
      this._loopstart = value * this.loopLength;
      this.buffer.loopStart = this._loopstart;
    }
  }, {
    key: "loopEnd",
    set: function set(value) {
      this._loopend = value * this.loopLength;
      this.buffer.loopEnd = this._loopend;
    }
  }, {
    key: "loopLength",
    get: function get() {
      return this.buffer.buffer.duration;
    }
  }]);

  return SamplePlayer;
}(Voice);

export { SamplePlayer as default };